import { z } from 'zod'
import { formItemSchema } from './form-item'

export const inputNumberSchema = formItemSchema.extend({
  type: z.literal('input-number'),
  clearable: z.boolean().optional(),
  min: z.number().optional(),
  max: z.number().optional(),
  step: z.number().optional(),
  width: z.string().default('100px').describe('宽度'),
  controls: z.boolean().default(false).describe('是否使用控制按钮'),
})

export type InputNumberSchema = z.infer<typeof inputNumberSchema>
